const columns = (CATEGORY_LIST, TYPE_LIST) => ([
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Sms',
    dataIndex: '',
    key: 'body',
    customRender: ({ value }) => (value.isEdit ? value.body.slice(0, 25) : 'HARDCODE'),
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    filters: CATEGORY_LIST,
    onFilter: (value, record) => (record.category || '').indexOf(value) === 0,
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    filters: TYPE_LIST,
    onFilter: (value, record) => (record.type || '').indexOf(value) === 0,
  },
  {
    title: 'Default',
    dataIndex: 'isDefault',
    key: 'default',
    customRender: ({ value }) => (value ? 'Yes' : 'No'),
  },
  {
    title: 'Edit',
    dataIndex: 'isEdit',
    key: 'edit',
    customRender: ({ value }) => (value ? 'Yes' : 'No'),
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
